import { ReactNode, useReducer } from 'react';

import ACTIONS from '@enums/contextActions';
import AppActionProps from '@models/actionProps';
import AppState from '@models/appState';

import AppContext from './context';
import InitialAppContext from './initialState';

export const AppProvider = ({ children, initialState = InitialAppContext }: { children: ReactNode; initialState?: AppState }) => {
  const reducer = (state: AppState, action: AppActionProps) => {
    switch (action.type) {
      case ACTIONS.UPDATE_APP_CONTEXT:
        return { ...state, ...action.payload };
      case ACTIONS.RESET_APP_CONTEXT:
        return initialState;
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
};
